











import Vue from 'vue';
export default Vue.extend({
  name: 'MStoreDescriptionButton',
  props: {
    id: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: false
    },
    size: {
      type: String,
      default: 'sm'
    },
    iconSize: {
      type: String,
      default: 'sm'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    cssClass: {
      type: String,
      default: null
    },
    cssStyle: {
      type: String,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  }
});
